<template>
  <div>
    <input
      v-for="(cell, index) in cells"
      :key="cell.key"
      :ref="`pin_cell${index}`"
      :disabled="locked"
      :style="{ width: 100 / template.length + '%' }"
      class="form-item-pin"
      autocomplete="off"
      autocorrect="off"
      autocapitalize="off"
      spellcheck="false"
      placeholder="0"
      type="text"
      inputmode="numeric"
      pattern="[0-9]*"
      v-bind="$attrs"
      v-model.trim="cell.value"
      @focus="focusedCellIndex = index"
      @keydown.delete="onCellErase(index, $event)"
      @keydown="onKeyDown"
      @keyup.enter="submit()"
    />
  </div>
</template>

<script>
export default {
  props: {
    answer: {
      type: String
    },
    template: Object,
    locked: Boolean
  },
  data: () => ({
    focusedCellIndex: 0,
    cells: [],
    watchers: {},
    cellsInputTypes: {}
  }),
  computed: {
    pinCodeComputed() {
      return this.cells.reduce((pin, cell) => pin + cell.value, '')
    },
    length() {
      return this.template.length
    }
  },
  watch: {
    answer(value) {
      if (value) {
        this.onParentValueUpdated()
      } else {
        this.reset()
      }
    },
    template() {
      //   this.reset()
    },
    pinCodeComputed(val) {
      this.$emit('answer-updated', val)
    }
  },
  mounted() {
    this.init()
    this.onParentValueUpdated()
    this.$nextTick(this.focusCellByIndex)
  },
  methods: {
    init() {
      this.cells = []
      for (let key = 0; key < this.length; key += 1) {
        this.setCellObject(key)
        this.setCellWatcher(key)
      }
    },
    setCellObject(key) {
      this.$set(this.cells, key, { key, value: '' })
    },
    setCellWatcher(index) {
      const watchingProperty = `cells.${index}.value`
      this.watchers[watchingProperty] = this.$watch(
        watchingProperty,
        (newVal, oldVal) => {
          this.onCellChanged(index, newVal, oldVal)
        }
      )
    },
    /* handlers */
    onParentValueUpdated() {
      if (this.answer?.length !== this.length) {
        return
      }
      this.answer?.split('').forEach((cell, index) => {
        this.cells[index].value = cell || ''
      })
    },
    onCellChanged(index, newVal) {
      if (!this.isTheCellValid(newVal, false)) {
        this.cells[index].value = ''
        return
      }
      this.focusNextCell()
    },
    onCellErase(index, e) {
      const isThisCellFilled = this.cells[index].value.length
      if (!isThisCellFilled) {
        this.focusPreviousCell()
        e.preventDefault()
      }
    },
    onKeyDown(e) {
      switch (e.keyCode) {
        /* left arrow key */
        case 37:
          this.focusPreviousCell()
          break
        /* right arrow key */
        case 39:
          this.focusNextCell()
          break
        default:
          break
      }
    },
    submit() {
      this.$emit('submit')
    },

    /* reset stuff */
    reset() {
      this.unwatchCells()
      this.init()
      this.focusCellByIndex()
    },
    unwatchCells() {
      const watchers = Object.keys(this.watchers)
      watchers.forEach(name => this.watchers[name]())
    },
    /* helpers */
    isTheCellValid(cell, allowEmpty = true) {
      if (!cell) {
        return allowEmpty ? cell === '' : false
      }
      return !!cell.match('^\\d{1}$')
    },
    focusPreviousCell() {
      if (!this.focusedCellIndex) return
      this.focusCellByIndex(this.focusedCellIndex - 1)
    },
    focusNextCell() {
      if (this.focusedCellIndex === this.length - 1) return
      this.focusCellByIndex(this.focusedCellIndex + 1)
    },
    focusCellByIndex(index = 0) {
      const ref = `pin_cell${index}`
      const el = this.$refs[ref][0]
      el.focus()
      el.select()
      this.focusedCellIndex = index
    }
  }
}
</script>
